
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.17.0
 * Query Engine version: 393aa359c9ad4a4bb28630fb5613f9c281cde053
 */
Prisma.prismaVersion = {
  client: "5.17.0",
  engine: "393aa359c9ad4a4bb28630fb5613f9c281cde053"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  password: 'password',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  account_type: 'account_type',
  status: 'status',
  role_id: 'role_id',
  phone_number: 'phone_number',
  otp: 'otp',
  firstName: 'firstName',
  lastName: 'lastName'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  firstName: 'firstName',
  lastName: 'lastName',
  street: 'street',
  address_2: 'address_2',
  city: 'city',
  state: 'state',
  zipCode: 'zipCode',
  country: 'country',
  phone: 'phone',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RoleScalarFieldEnum = {
  role_id: 'role_id',
  role_name: 'role_name',
  description: 'description'
};

exports.Prisma.PermissionScalarFieldEnum = {
  permission_id: 'permission_id',
  permission_name: 'permission_name',
  description: 'description',
  created_at: 'created_at'
};

exports.Prisma.RolePermissionScalarFieldEnum = {
  role_id: 'role_id',
  permission_id: 'permission_id'
};

exports.Prisma.ProductScalarFieldEnum = {
  product_id: 'product_id',
  status: 'status',
  user_id: 'user_id',
  product_name: 'product_name',
  isOnlineBuyable: 'isOnlineBuyable',
  featured: 'featured',
  country_id: 'country_id',
  categoryId: 'categoryId',
  subCategoryId: 'subCategoryId',
  offline_reason: 'offline_reason',
  delivery_includes: 'delivery_includes',
  return_policy: 'return_policy',
  purchase_note: 'purchase_note'
};

exports.Prisma.ViewedProductScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  productId: 'productId'
};

exports.Prisma.RelatedProductScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  relatedProductId: 'relatedProductId'
};

exports.Prisma.VendorScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  store_name: 'store_name',
  store_url: 'store_url',
  license_number: 'license_number',
  issued_at: 'issued_at',
  issued_date: 'issued_date',
  expiry_date: 'expiry_date',
  licence_address: 'licence_address',
  licence_city: 'licence_city',
  licence_state: 'licence_state',
  licence_zip_code: 'licence_zip_code',
  licence_country: 'licence_country',
  account_name: 'account_name',
  account_number: 'account_number',
  bank_name: 'bank_name',
  routing_number: 'routing_number',
  bank_iban: 'bank_iban',
  bank_swift_code: 'bank_swift_code',
  bank_address: 'bank_address',
  bank_city: 'bank_city',
  bank_state: 'bank_state',
  bank_zip_code: 'bank_zip_code',
  bank_country: 'bank_country'
};

exports.Prisma.CategoryScalarFieldEnum = {
  category_id: 'category_id',
  name: 'name',
  description: 'description',
  created_at: 'created_at',
  updated_at: 'updated_at',
  category_image: 'category_image',
  parent_id: 'parent_id'
};

exports.Prisma.CountryScalarFieldEnum = {
  country_id: 'country_id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at',
  region: 'region'
};

exports.Prisma.TagScalarFieldEnum = {
  tag_id: 'tag_id',
  name: 'name',
  description: 'description',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.ProductTagScalarFieldEnum = {
  product_id: 'product_id',
  tag_id: 'tag_id'
};

exports.Prisma.AttributeScalarFieldEnum = {
  attribute_id: 'attribute_id',
  name: 'name',
  isRequired: 'isRequired',
  isMultiple: 'isMultiple',
  description: 'description',
  created_at: 'created_at',
  updated_at: 'updated_at',
  useForVariation: 'useForVariation'
};

exports.Prisma.AttributeValueScalarFieldEnum = {
  id: 'id',
  name: 'name',
  colorCode: 'colorCode',
  attribute_id: 'attribute_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.ProductAttributeScalarFieldEnum = {
  product_id: 'product_id',
  attribute_id: 'attribute_id'
};

exports.Prisma.ProductAttributeValueScalarFieldEnum = {
  product_id: 'product_id',
  attribute_id: 'attribute_id',
  attributeValue_id: 'attributeValue_id',
  productAttributeValue_id: 'productAttributeValue_id'
};

exports.Prisma.AttributeValuePricingScalarFieldEnum = {
  pricing_id: 'pricing_id',
  name: 'name',
  attributeValue_id: 'attributeValue_id',
  price: 'price',
  base_q: 'base_q',
  unit: 'unit',
  purity: 'purity'
};

exports.Prisma.PricingHistoryScalarFieldEnum = {
  pricingHistory_id: 'pricingHistory_id',
  date: 'date',
  karat24: 'karat24',
  karat22: 'karat22',
  karat21: 'karat21',
  karat18: 'karat18',
  karat14: 'karat14',
  karat09: 'karat09',
  silver: 'silver',
  platinum: 'platinum',
  palladium: 'palladium',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.CollectionScalarFieldEnum = {
  collection_id: 'collection_id',
  name: 'name',
  description: 'description'
};

exports.Prisma.ProductCollectionScalarFieldEnum = {
  collection_id: 'collection_id',
  product_id: 'product_id'
};

exports.Prisma.PatternScalarFieldEnum = {
  pattern_id: 'pattern_id',
  name: 'name',
  description: 'description'
};

exports.Prisma.ProductPattenScalarFieldEnum = {
  pattern_id: 'pattern_id',
  product_id: 'product_id'
};

exports.Prisma.StateScalarFieldEnum = {
  state_id: 'state_id',
  name: 'name',
  country_id: 'country_id'
};

exports.Prisma.ProductStateScalarFieldEnum = {
  state_id: 'state_id',
  product_id: 'product_id'
};

exports.Prisma.GenderScalarFieldEnum = {
  gender_id: 'gender_id',
  name: 'name'
};

exports.Prisma.ProductGenderScalarFieldEnum = {
  gender_id: 'gender_id',
  product_id: 'product_id'
};

exports.Prisma.CharacteristicScalarFieldEnum = {
  chars_id: 'chars_id',
  name: 'name',
  chars_type: 'chars_type'
};

exports.Prisma.ProductCharsScalarFieldEnum = {
  chars_id: 'chars_id',
  product_id: 'product_id'
};

exports.Prisma.ProductVariationScalarFieldEnum = {
  variation_id: 'variation_id',
  product_id: 'product_id',
  variation_name: 'variation_name',
  description: 'description',
  sku: 'sku',
  stock_management: 'stock_management',
  stock_status: 'stock_status',
  quantity: 'quantity',
  length: 'length',
  height: 'height',
  width: 'width',
  thickness: 'thickness',
  weight_unit: 'weight_unit',
  net_weight: 'net_weight',
  gross_weight: 'gross_weight',
  isPriceFixed: 'isPriceFixed',
  making_charges: 'making_charges',
  other_charges: 'other_charges',
  regular_price: 'regular_price',
  selling_price: 'selling_price',
  isDiscount: 'isDiscount',
  variation_discount: 'variation_discount',
  variation_discount_type: 'variation_discount_type'
};

exports.Prisma.ImageScalarFieldEnum = {
  image_id: 'image_id',
  path: 'path',
  image_type: 'image_type',
  variation_id: 'variation_id',
  user_id: 'user_id',
  category_id: 'category_id',
  review_id: 'review_id',
  pod_id: 'pod_id'
};

exports.Prisma.GemstoneScalarFieldEnum = {
  gemstone_id: 'gemstone_id',
  name: 'name',
  description: 'description'
};

exports.Prisma.GemstoneProductVariationScalarFieldEnum = {
  gemstone_id: 'gemstone_id',
  variation_id: 'variation_id'
};

exports.Prisma.ProductVariationAttributeScalarFieldEnum = {
  productVariation_id: 'productVariation_id',
  productAttributeValue_id: 'productAttributeValue_id'
};

exports.Prisma.CartScalarFieldEnum = {
  cart_id: 'cart_id',
  user_id: 'user_id',
  cart_total: 'cart_total',
  discount: 'discount',
  discount_type: 'discount_type'
};

exports.Prisma.CartItemScalarFieldEnum = {
  cartItem_id: 'cartItem_id',
  cart_id: 'cart_id',
  variation_id: 'variation_id',
  price: 'price',
  quantity: 'quantity'
};

exports.Prisma.OtpVerificationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  phone_number: 'phone_number',
  otp: 'otp',
  mode: 'mode',
  created_at: 'created_at',
  updated_at: 'updated_at',
  expiry: 'expiry'
};

exports.Prisma.OrderScalarFieldEnum = {
  id: 'id',
  shippingAddress: 'shippingAddress',
  billingAddress: 'billingAddress',
  paymentMethod: 'paymentMethod',
  paymentResponse: 'paymentResponse',
  orderTotal: 'orderTotal',
  paidAmount: 'paidAmount',
  orderDiscountTitle: 'orderDiscountTitle',
  orderDiscount: 'orderDiscount',
  status: 'status',
  cancelNote: 'cancelNote',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.OrderSellerRelationScalarFieldEnum = {
  order_id: 'order_id',
  user_id: 'user_id'
};

exports.Prisma.OrderItemScalarFieldEnum = {
  id: 'id',
  name: 'name',
  quantity: 'quantity',
  price: 'price',
  sellerId: 'sellerId',
  discountTitle: 'discountTitle',
  discount: 'discount',
  variationData: 'variationData',
  orderId: 'orderId',
  productVariationId: 'productVariationId'
};

exports.Prisma.ReviewScalarFieldEnum = {
  id: 'id',
  rating: 'rating',
  text: 'text',
  recommandation: 'recommandation',
  createdAt: 'createdAt',
  status: 'status',
  replay: 'replay',
  fromUserId: 'fromUserId',
  userId: 'userId',
  productId: 'productId'
};

exports.Prisma.WishlistScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  productId: 'productId'
};

exports.Prisma.LikeScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  productId: 'productId'
};

exports.Prisma.ProductOnDemandScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  description: 'description',
  metal_type: 'metal_type',
  karat: 'karat',
  weight_type: 'weight_type',
  min_weight: 'min_weight',
  max_weight: 'max_weight',
  price_type: 'price_type',
  min_price: 'min_price',
  max_price: 'max_price',
  made_in: 'made_in',
  contact: 'contact',
  Status: 'Status',
  Note: 'Note'
};

exports.Prisma.LogsScalarFieldEnum = {
  id: 'id',
  type: 'type',
  details: 'details',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orderId: 'orderId'
};

exports.Prisma.HomeSliderScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  image_url: 'image_url',
  link_url: 'link_url',
  createdAt: 'createdAt'
};

exports.Prisma.PromotionalScalarFieldEnum = {
  ads_id: 'ads_id',
  ads_title: 'ads_title',
  ads_desc: 'ads_desc',
  ads_link: 'ads_link',
  ads_img_url: 'ads_img_url',
  ads_type: 'ads_type',
  createdAt: 'createdAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.AcountType = exports.$Enums.AcountType = {
  CUSTOMER: 'CUSTOMER',
  ADMIN: 'ADMIN',
  VENDOR: 'VENDOR'
};

exports.UserStatus = exports.$Enums.UserStatus = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  SUSPENDED: 'SUSPENDED'
};

exports.AddressType = exports.$Enums.AddressType = {
  BILLING: 'BILLING',
  SHIPPING: 'SHIPPING',
  OTHER: 'OTHER'
};

exports.ProductStatus = exports.$Enums.ProductStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
};

exports.CharsType = exports.$Enums.CharsType = {
  BRAND: 'BRAND',
  STYLE: 'STYLE',
  THEME: 'THEME',
  TREND: 'TREND'
};

exports.OrderStatus = exports.$Enums.OrderStatus = {
  PENDING: 'PENDING',
  OUTOFSTOCK: 'OUTOFSTOCK',
  USERCANCELLED: 'USERCANCELLED',
  SELLERCANCELLED: 'SELLERCANCELLED',
  PROCESSING: 'PROCESSING',
  PACKED: 'PACKED',
  SHIPPED: 'SHIPPED',
  OUTFORDELIVERY: 'OUTFORDELIVERY',
  DELIVERED: 'DELIVERED'
};

exports.ReviewStatus = exports.$Enums.ReviewStatus = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED'
};

exports.PODStatus = exports.$Enums.PODStatus = {
  DRAFT: 'DRAFT',
  REQUESTED: 'REQUESTED',
  PUBLISHED: 'PUBLISHED',
  ACCEPTEDBYSELLER: 'ACCEPTEDBYSELLER',
  SOLD: 'SOLD',
  CANCELED: 'CANCELED',
  ARCHIVED: 'ARCHIVED'
};

exports.LOGTYPES = exports.$Enums.LOGTYPES = {
  LOG: 'LOG',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  DEV: 'DEV'
};

exports.adsType = exports.$Enums.adsType = {
  HOME: 'HOME',
  HOME_B: 'HOME_B',
  POD: 'POD',
  SHOP: 'SHOP',
  STORE: 'STORE',
  CART: 'CART',
  WISHLIST: 'WISHLIST'
};

exports.Prisma.ModelName = {
  Account: 'Account',
  User: 'User',
  Address: 'Address',
  Role: 'Role',
  Permission: 'Permission',
  RolePermission: 'RolePermission',
  Product: 'Product',
  ViewedProduct: 'ViewedProduct',
  RelatedProduct: 'RelatedProduct',
  Vendor: 'Vendor',
  Category: 'Category',
  Country: 'Country',
  Tag: 'Tag',
  ProductTag: 'ProductTag',
  Attribute: 'Attribute',
  AttributeValue: 'AttributeValue',
  ProductAttribute: 'ProductAttribute',
  ProductAttributeValue: 'ProductAttributeValue',
  attributeValuePricing: 'attributeValuePricing',
  PricingHistory: 'PricingHistory',
  Collection: 'Collection',
  ProductCollection: 'ProductCollection',
  Pattern: 'Pattern',
  ProductPatten: 'ProductPatten',
  State: 'State',
  ProductState: 'ProductState',
  Gender: 'Gender',
  ProductGender: 'ProductGender',
  Characteristic: 'Characteristic',
  ProductChars: 'ProductChars',
  ProductVariation: 'ProductVariation',
  Image: 'Image',
  Gemstone: 'Gemstone',
  GemstoneProductVariation: 'GemstoneProductVariation',
  ProductVariationAttribute: 'ProductVariationAttribute',
  Cart: 'Cart',
  CartItem: 'CartItem',
  OtpVerification: 'OtpVerification',
  Order: 'Order',
  OrderSellerRelation: 'OrderSellerRelation',
  OrderItem: 'OrderItem',
  Review: 'Review',
  Wishlist: 'Wishlist',
  Like: 'Like',
  ProductOnDemand: 'ProductOnDemand',
  Logs: 'Logs',
  HomeSlider: 'HomeSlider',
  Promotional: 'Promotional'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
